import * as Promise from 'bluebird';
import dayjs from 'dayjs';

import * as FileSystemService from '../file/fileSystemService';
import * as contentActions from '../../actions/contentActions';
import { getLogger } from '../logger';
import { BOOK_DOWNLOADING_STATUS } from '../../const';
import * as contentPathUtils from '../../utils/contentPathUtils';

const debug = getLogger('services:domain:contentService');

export let unZipActivityContentWithPercentage = (pathToFile, destination, activityContent, fromRemoteRepo) => {
  return async dispatch => {
    try {
      activityContent.downloadStatus = BOOK_DOWNLOADING_STATUS.UNZIPPING;
      // TODO: Update activity status instead of update activity
      dispatch(contentActions.setActivityContent(activityContent));

      dispatch(contentActions.updateUnzippingStatusWhereApplicable(activityContent.classId, activityContent.bookId));

      const onProgress = progress => {
        activityContent.unzipPercentage = Math.floor(progress.percentage);
        dispatch(contentActions.setActivityContent(activityContent));
      };

      await unzipBookResourceWithPercentage(pathToFile, destination, onProgress, fromRemoteRepo);
      activityContent.downloadStatus = BOOK_DOWNLOADING_STATUS.COMPLETED;
      dispatch(contentActions.setActivityContent(activityContent));
    } catch (err) {
      console.error(err);
      debug.error('[unZipActivityContentWithPercentage] error unzipping activity content %s', err);
      throw err;
    }
  };
};

export function downloadFile(authToken, url, zipFilePath, folderFilePath, parentFolderPath) {
  return new Promise(async (resolve, reject) => {
    try {
      if (parentFolderPath) {
        if (FileSystemService.existsFile(parentFolderPath)) {
          if (FileSystemService.existsFile(zipFilePath)) await FileSystemService.remove(zipFilePath);
          if (FileSystemService.existsFile(folderFilePath)) await FileSystemService.remove(folderFilePath);
          const tempZipFile = FileSystemService.getTemporaryFileName(zipFilePath);
          if (FileSystemService.existsFile(tempZipFile)) await FileSystemService.remove(tempZipFile);
        } else {
          await FileSystemService.createFolder(parentFolderPath);
        }
      }

      const onStart = (size, percentage) => debug('[downloadFile] download start');
      const onData = (request, percentage) => debug(`[downloadFile] download progress ${percentage}%`);
      const onProgress = progress => debug(`[downloadFile] unzip progress ${progress.percentage}%`);

      const onEnd = async () => {
        try {
          await FileSystemService.createFolder(folderFilePath);
          await unzipFile(zipFilePath, folderFilePath, onProgress);
          debug('[downloadFile] unzip completed');
          resolve({});
        } catch (err) {
          reject(new Error('[downloadFile]', err));
        }
      };

      const onErr = err => {
        console.error(err);
        reject(err);
      };

      const options = FileSystemService.httpRequestOptions({ url, authToken });
      return await FileSystemService.httpGetWithProgress(options, onStart, onData, onEnd, onErr, zipFilePath);
    } catch (err) {
      console.log(err);
      debug.error('[downloadFile] Unable to save content to file', err, err.stack);
      FileSystemService.remove(zipFilePath);
      reject(err);
    }
  });
}

export async function writeBookDownloadCheckFile(bookContext) {
  const bookDownloadCheckFile = contentPathUtils.getBookDownloadCheckFile(bookContext);
  await FileSystemService.saveJsonToFile(bookDownloadCheckFile, { date: dayjs() });
}

export async function writeUnitDownloadCheckFile(unitContext) {
  const unitDownloadCheckFile = contentPathUtils.getUnitDownloadCheckFile(unitContext);
  await FileSystemService.saveJsonToFile(unitDownloadCheckFile, { date: dayjs() });
}

export function removeBookDownloadCheckFileIfExists(bookContext) {
  const bookDownloadCheckFile = contentPathUtils.getBookDownloadCheckFile(bookContext);
  FileSystemService.removeFile(bookDownloadCheckFile);
}

async function unzipBookResourceWithPercentage(pathToFile, destination, onProgress) {
  await FileSystemService.unZipContentWithPercentage(pathToFile, destination, onProgress);
  await FileSystemService.removeFile(pathToFile);
}

async function unzipFile(pathToFile, destination, onProgress) {
  await FileSystemService.unZipFiles(pathToFile, destination, onProgress);
  await FileSystemService.removeFile(pathToFile);
}
